<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { mloc } from "module/utils";
  import NiceButton from "../NiceButton.svelte";

  let { open, title }: { open: boolean; title: string } = $props();

  const dispatch = createEventDispatcher();

  const close = () => dispatch("close");
</script>

<div class="backdrop" class:open on:click={close}></div>
<section class:open>
  <header>
    <h3>
      <i class="fas fa-chevron-left" on:click={close} title={"Back"}></i>
      <span on:click={close} title={"Back"}>{title}</span>
    </h3>
  </header>
  <slot />
  <footer>
    <NiceButton on:click={() => dispatch("close")}>
      {mloc("FilterEditorDone")}
    </NiceButton>
    <NiceButton on:click={() => dispatch("clear")}>
      {mloc("FilterEditorDeselectAll")}
    </NiceButton>
  </footer>
</section>

<style>
  section {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--qiFilterAccent);
    overflow: auto;
    flex-direction: column;
  }

  .backdrop {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
  }

  header {
    padding: 0 0.1em;
    border-bottom: 2px solid #333;
  }

  h3 {
    margin: 0;
    border: none;
    display: flex;
    align-items: stretch;
  }

  span {
    flex-grow: 1;
    padding: 0.4em 0;
  }

  .fa-chevron-left {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
  }

  .open {
    display: flex;
  }

  footer {
    display: flex;
    padding: 0.4em 1em;
  }
</style>
